import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-info-banner',
  templateUrl: './info-banner.component.html',
  styleUrls: ['./info-banner.component.scss'],
})
export class InfoBannerComponent {
  @Input() message = '';
  // Optional second line rendered under the message with a leading bullet (e.g. error codes).
  @Input() detail = '';
  @Input() background = '';
  @Input() iconColor = '';
  // ARIA role for the banner container: "status" for informational, "alert" for errors.
  @Input() role = 'status';
}
